import { useMemo } from 'react';
import { useData } from '@grcs/context/DataContext';
import { AccountService } from '@grcs/utils/auth/AccountService';

export const useAccountManagement = () => {
  const { supabase } = useData();
  return useMemo(() => new AccountService(supabase), [supabase]);
};
